import { parsePath, parseSuffix } from "@volkswagen-onehub/cms-utils";
import { URLSearchParams } from "../internal/url-search-params";
export const getPrimaryPath = (pathname) => {
    const path = parsePath(pathname);
    return path.base;
};
export const getNodeId = (pathname) => {
    const path = parsePath(pathname);
    if (!path.suffix) {
        return undefined;
    }
    return parseSuffix(path.suffix).default.substring(1);
};
export const createShowroomPath = (path, extension, noSuffix) => {
    const { nodeId, pathname } = path;
    const extensionWithDot = extension ? "." + extension : "";
    return noSuffix
        ? pathname
        : pathname + (nodeId ? `/${nodeId}${extensionWithDot}` : "");
};
function addParameters(params, key, config) {
    const value = config[key];
    if (value) {
        params.append(key, value);
    }
}
export const getRelativeNodeId = (nodeId, baseNodeId) => {
    if (nodeId.startsWith(baseNodeId)) {
        return nodeId.substring(baseNodeId.length + 1);
    }
    return undefined;
};
export const getAbsoluteNodeId = (relativeNodeId, baseNodeId) => {
    if (relativeNodeId.startsWith("/")) {
        return relativeNodeId;
    }
    const absoluteNodeId = `${baseNodeId}/${relativeNodeId}`;
    return absoluteNodeId;
};
export const createParamsFromConfig = (config) => {
    const params = new URLSearchParams();
    addParameters(params, "modelId", config);
    addParameters(params, "modelYear", config);
    addParameters(params, "modelVersion", config);
    addParameters(params, "exteriorId", config);
    addParameters(params, "interiorId", config);
    if (config.options) {
        config.options.forEach(option => {
            params.append("option", option);
        });
    }
    return params;
};
export const readParamsToConfig = (params, trimConfig) => {
    const keys = [
        "modelId",
        "modelYear",
        "modelVersion",
        "exteriorId",
        "interiorId"
    ];
    let config = Object.assign({}, trimConfig);
    keys.forEach(key => {
        const value = params.get(key);
        if (typeof params !== "undefined" && value !== null) {
            config = Object.assign(Object.assign({}, config), { [key]: value });
        }
    });
    const options = params.getAll("option");
    if (typeof options !== "undefined" &&
        options !== null &&
        options.length !== 0) {
        config = Object.assign(Object.assign({}, config), { options });
    }
    return config;
};
export const equalString = (value1, value2) => {
    const equal = (!value1 && !value2) || value1 === value2;
    return equal;
};
export const createSubpaths = (path) => {
    const segments = path.split("/");
    let idx = 0;
    const paths = [];
    while (idx < segments.length) {
        const thePath = segments
            .filter((_seg, index) => index < segments.length - idx)
            .join("/");
        paths.push(thePath);
        idx++;
    }
    return paths;
};
export const isSubpath = (subPath, parentPath) => {
    if (subPath.length < parentPath.length) {
        return false;
    }
    if (!subPath.startsWith(parentPath)) {
        return false;
    }
    const firstRemainingLetter = subPath[parentPath.length];
    return firstRemainingLetter === "/";
};
